import { useEffect } from "react";
import { Status } from '../../../common/constants'
import { actions as spinnerActions, selector } from '../../../components/ui/spinner/spinnerSlice';
import { useDispatch, useSelector } from "react-redux";

export const useSpinner = (apiData?: string) => {
    const dispatch = useDispatch();
    const apiStatuses = useSelector((selector)).apiStatus;

    useEffect(() => {
        const isLoading: boolean = apiStatuses.some(status => status == Status.PENDING);
        if (apiData === Status.PENDING || isLoading) {
            dispatch(spinnerActions.showSpinner());
        } else {
            dispatch(spinnerActions.hideSpinner());
        }
    }, [apiStatuses, apiData, dispatch]);

}